import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { insertShare, updateShare, getShareDetail, fetchShareMeterList, selectManagerArea } from "@/api/PMS/baseInformation/meterManager";
import { fetchList as getMeterTypeList } from "@/api/PMS/baseInformation/meterType";
import { fetchListByType } from "@/api/system/dic/dic";
import addTrees from "./addTrees";
export default {
  components: {
    addTrees: addTrees
  },
  data: function data() {
    return {
      rules: {
        areaId: [{
          required: true,
          message: "请选择小区名称",
          trigger: "change"
        }],
        shareMode: [{
          required: true,
          message: "请选择分摊方式",
          trigger: "change"
        }],
        meterId: [{
          required: true,
          message: "请选择仪表类型",
          trigger: "change"
        }],
        currentRead: [{
          required: true,
          type: "number",
          message: "请输入初始读数，类型为数字，0<=初始读数<=100000",
          trigger: "blur",
          max: 100000,
          min: 0,
          transform: function transform(value) {
            return Number(value);
          }
        }],
        meterRemark: [{
          trigger: "blur",
          max: 100,
          message: "备注长度不能超过100个字符"
        }],
        meterPower: [{
          required: true,
          type: "number",
          message: "请输入倍率，类型为数字,0<倍率<100",
          max: 99.99,
          min: 0.01,
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        readDate: [{
          required: true,
          message: "请选择读数日期",
          trigger: "blur"
        }],
        returnTrip: [{
          required: true,
          type: "number",
          message: "请输入回程，类型为数字",
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        meterWastageRate: [{
          type: "number",
          transform: function transform(value) {
            if (value !== undefined && value !== null) return Number(value);
          },
          max: 99.99,
          min: 0,
          message: "损耗率类型为数字,类型为数字,0<=损耗率<100",
          trigger: "blur"
        }],
        shareMeterName: [{
          required: true,
          message: "请输入仪表名称，仪表名称在1-20个字符",
          max: 20,
          min: 0,
          trigger: "blur"
        }]
      },
      shareMeterList: [],
      meterTypeList: [],
      shareModeList: [],
      multipleSelection: [],
      shareList: [],
      // 分摊仪表集合
      areaList: [],
      houseList: [],
      // 分摊房间集合
      title: "",
      dialogFormVisible: false,
      childData: {
        shareType: 1,
        meterPower: 1,
        returnTrip: 0
      }
    };
  },
  props: ["keyValue", "showDialog"],
  created: function created() {
    this.init();
    this.loadGroupList();
    this.loadMeterTypeList();
    this.getShareType();
  },
  methods: {
    loadGroupList: function loadGroupList() {
      var _this = this;

      selectManagerArea({}).then(function (r) {
        _this.areaList = r.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          shareMeterId: this.keyValue
        };
        getShareDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          console.log(_this2.childData);

          if (_this2.childData.shareType === 1) {
            _this2.shareList = _this2.childData.shareList;
          } else if (_this2.childData.shareType === 0) {
            _this2.houseList = _this2.childData.houseList;
          }
        });
      } else {
        this.shareList = [];
        this.houseList = [];
        this.childData = {
          shareMeterName: "",
          shareType: 1,
          meterPower: 1,
          returnTrip: 0
        };
      }
    },
    // 添加分摊报表
    handleShareMeter: function handleShareMeter() {
      this.dialogFormVisible = true;
      this.title = "添加分摊仪表";
    },
    // 删除分摊仪表
    deleteShareMeter: function deleteShareMeter() {
      this.deleteShareHouse();
    },
    // 添加分摊房间
    hamdleShareHouse: function hamdleShareHouse() {
      this.dialogFormVisible = true;
      this.title = "添加分摊房间";
    },
    // 删除分摊房间
    deleteShareHouse: function deleteShareHouse() {
      var _this3 = this;

      var list = [];

      if (this.childData.shareType === 1) {
        list = this.shareList;
      } else if (this.childData.shareType === 0) {
        list = this.houseList;
      }

      if (this.multipleSelection.length > 0) {
        this.$confirm("你确定是要删除这些数据, 是否继续?", "提示").then(function () {
          _this3.multipleSelection.forEach(function (row) {
            for (var i = 0; i < list.length; i++) {
              var item = list[i];

              if (item.id === row.id) {
                if (i > -1) {
                  list.splice(i, 1);
                }
              }
            }
          });

          _this3.Alert({
            alertType: "delete"
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 企业选择发生变化的时候触发
    areaChange: function areaChange() {
      // 清理总表id
      if (this.childData.shareMeterId) {
        delete this.childData.shareMeterId;
      }

      this.loadShareMeterList();
    },
    // 获取总表列表
    loadShareMeterList: function loadShareMeterList() {
      var _this4 = this;

      fetchShareMeterList({
        shareType: 1,
        areaId: this.childData.areaId
      }).then(function (r) {
        _this4.shareMeterList = r.data.data;
      });
    },
    // 获取仪表类型
    loadMeterTypeList: function loadMeterTypeList() {
      var _this5 = this;

      getMeterTypeList({}).then(function (r) {
        _this5.meterTypeList = r.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this6.childData.detialList = [];

          if (_this6.childData.shareType === 1) {
            _this6.shareList.forEach(function (element) {
              _this6.childData.detialList.push(element.id);
            });
          } else if (_this6.childData.shareType === 0) {
            _this6.houseList.forEach(function (element) {
              _this6.childData.detialList.push(element.id);
            });
          }

          if (_this6.keyValue > 0) {
            //  this.childData.detialList = [];
            updateShare(_this6.childData).then(function (response) {
              if (response.data.code === 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            // console.log(this.childData)
            insertShare(_this6.childData).then(function (response) {
              if (response.data.code === 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    },
    handTreeCancle: function handTreeCancle(list) {
      this.dialogFormVisible = false;
      console.log(list);

      if (list !== null && list.length > 0) {
        // 总表
        if (this.childData.shareType === 1) {
          this.shareList = list; // 公摊房间
        } else {
          this.houseList = list;
        }
      }
    },
    getShareType: function getShareType() {
      var _this7 = this;

      fetchListByType("share_mode").then(function (r) {
        _this7.shareModeList = r.data.data;
      });
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};